'use client';

import type { BankDetails } from '@/api/entities';
import { Show } from '@/components/conditional-component';
import { useDeletePaymentMethod } from '@/hooks/query-hooks/use-delete-payment';
import Image from 'next/image';
import defaultLogo from '../../../../../public/banks/default.svg';
import { useProfile } from '../../../../components/providers/profile-provider';
import { BankIconMap } from '../utils/constants';
import AddNewPayment from './add-new-payment';
import PaymentCard from './bank-card';
export type PaymentMethods = {
  bank?: BankDetails;
  upi?: string;
} | undefined;
export default function PaymentDetails() {
  const {
    paymentMethods
  } = useProfile();
  const {
    handleDelete
  } = useDeletePaymentMethod();
  const handlePaymentDelete = async (method: 'bank' | 'upi') => {
    try {
      await handleDelete(method);
    } catch (error) {
      // Handle error (e.g., show toast notification)
      console.error('Error deleting payment method:', error);
    }
  };
  return <div className="flex w-full flex-col gap-2" data-sentry-component="PaymentDetails" data-sentry-source-file="payment-details.tsx">
      {paymentMethods?.bank && <PaymentCard title={paymentMethods.bank.bankName} identifier={paymentMethods.bank.accountNumber} isVerified onDelete={() => handlePaymentDelete('bank')} icon={<Image src={BankIconMap[paymentMethods.bank.bankCode as keyof typeof BankIconMap] ?? defaultLogo} width={100} height={100} alt={paymentMethods.bank.bankCode} className="w-full object-cover" />} />}
      {paymentMethods?.upi && <PaymentCard title="UPI ID" identifier={paymentMethods.upi} onDelete={() => handlePaymentDelete('upi')} isVerified icon={<Image src="/upi.svg" alt="UPI" width={100} height={100} />} />}
      <Show when={!paymentMethods?.upi || !paymentMethods.bank} data-sentry-element="Show" data-sentry-source-file="payment-details.tsx">
        <AddNewPayment data-sentry-element="AddNewPayment" data-sentry-source-file="payment-details.tsx" />
      </Show>
    </div>;
}